import Header from '@components/Header';
import TabItem from '@components/tab/TabItem';
import TabList from '@components/tab/TabList';
import { useStepFlow } from '@router/stackflow';
import { AppScreen } from '@stackflow/plugin-basic-ui';
import { ActivityComponentType } from '@stackflow/react';

import GiftBoxFragment from './fragments/GiftBoxFragment';
import GiftCategoryFragment from './fragments/GiftCategoryFragment';
import GiftMainFragment from './fragments/GiftMainFragment';

interface Params {
    type: 'MAIN' | 'CATEGORY' | 'BOX';
}

const GiftsActivity: ActivityComponentType<Params> = ({ params }:{params: Params}) => {
  const { type } = params;
  const { stepReplace } = useStepFlow('GiftsActivity');
  return (
      <AppScreen>
          <Header title='선물하기' />
          <TabList variant='solid'>
              <TabItem selected={type === 'MAIN'}
                       onClick={() => stepReplace({ type: 'MAIN' })} >
                  메인
              </TabItem>
              <TabItem selected={type === 'CATEGORY'}
                       onClick={() => stepReplace({ type: 'CATEGORY' })} >
                  카테고리
              </TabItem>
              <TabItem selected={type === 'BOX'}
                       onClick={() => stepReplace({ type: 'BOX' })} >
                  선물함
              </TabItem>
          </TabList>
          {type === 'MAIN' && (
              <GiftMainFragment/>
          )}
          {type === 'CATEGORY' && (
              <GiftCategoryFragment/>
          )}
          {type === 'BOX' && (
              <GiftBoxFragment/>
          )}
      </AppScreen>
  );
};

export default GiftsActivity;
